<template>
  <div>
    <template v-for="menu in list">
      <el-submenu
        v-if="menu.children && menu.children.length > 0"
        :index="String(menu.typeId)"
        :key="menu.typeId"
        
      >
        <template slot="title">
          <!-- {{isActive}} -->
        <div :class="isActive==0?'title_box':'title_box1'">
          <span  @click="selectTop(menu.typeId)" :class="[selectItem==menu.typeId?'blue':'',isActive==0?'title1':'title2']">{{ menu.typeName }}</span>
        </div>
          
        </template>
        <!-- 调用自身-->
        <Submenu :list="menu.children" :active="isActive"></Submenu>
      </el-submenu>
      <el-menu-item v-else :index="String(menu.typeId)" :key="menu.typeId" >
      <div :class="isActive==0?'title_box':'title_box1'">
        {{ menu.typeName }}
      </div>
        
      </el-menu-item>
    </template>
  </div>
</template>

<script>
export default {
  name: "Submenu",
  props: {
    list: {
      type: Array,
      default: [],
    },
    selectItem:{
      type: [String,Number],
      default: '',
    },
    isshow:{
      type:Boolean,
      default:true
    },
    active:{
      type:[String,Number],
      default:''
    }
  },
  data() {
    return {
      isActive:0
    };
  },
  watch:{
    active:{
      handler(newValue,oldValue){
        console.log('3843984=====active',newValue)
        this.isActive=newValue
      },
      immediate: true
    }
  },
  methods:{
    selectTop(e){
      this.$emit('selectTop',e)
    }
  }
};
</script>

<style scoped>
.blue{
  color:#409eff;
}
.title1{
  display:flex;
  justify-content:center;
  width:100%;
  height:100%;
}

.title2{
  display:flex;
  justify-content:flex-end;
  width:100%;
  height:100%;
}

.title_box{
  width:40%;
  display:flex;
  justify-content:center;
}

.title_box1{
  width:81%;
  /* border:1px solid red; */
  display:flex;
  justify-content:flex-end;
}

</style>



// WEBPACK FOOTER //
// src/components/Submenu.vue